import theme from "../../styles/__theme";
import { styled } from "../../utils/barrels/emotion-styled";

const { spacing, colors, fontSize } = theme;

export const PaginationWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
	width: 100%;
`;

export const PageNumberDisplay = styled.div`
	padding: 14px 16px;
	color: rgba(0, 0, 0, 0.54);
	font-weight: 500;
	font-size: ${fontSize.moderate};
	white-space: nowrap;
	min-width: fit-content;
`;

export const StyledMTablePagination = styled.div`
	width: fit-content;
	display: flex;
	align-items: center;
	justify-content: flex-end;

	.MuiIconButton-root {
		color: ${colors.purple};
		padding: ${spacing.compact};

		&:hover:not(:disabled) {
			background-color: ${colors.lightPurple};
			color: ${colors.darkPurple};
		}

		&:disabled {
			color: ${colors.silverGrey};
			opacity: 0.5;
			cursor: not-allowed;
		}

		&:focus {
			outline: 2px solid ${colors.purple};
			outline-offset: 2px;
		}
	}

	.MuiTypography-caption {
		color: ${colors.darkGrey};
		font-size: ${fontSize.moderate};
		margin: 0 ${spacing.comfortable};
	}

	.MuiTooltip-root {
		margin: 0;
	}
`;
